import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({})

const replyTime = (state = initialState, { type, payload, error, meta }) => {
  switch (type) {
    case actions.REQUEST_REPLY_TIME:
      return state.set(payload, {
        error: false,
        isFetching: true,
        payload: '',
      })
    case actions.RECEIVE_REPLY_TIME:
      if (error) {
        return state.merge(
          {
            [meta]: {
              error: true,
              isFetching: false,
              payload: '',
            },
          },
          { deep: true },
        )
      }

      return state.merge(
        {
          [meta]: {
            isFetching: false,
            payload,
          },
        },
        { deep: true },
      )
    default:
      return state
  }
}

export default replyTime
